import { FragmentDefiner, useReadFragment } from "../../../../GlobalHooks/useReadFragment";
import { GraphQLError } from "graphql";

export const FRAGMENT_PROPERTY_MODAL_TOUR3D = new FragmentDefiner(
	"Property",
	`
	id
	project {
		id
		tour3d
	}
`
);

export function usePropertyModalTour3d({
	id,
}): { loading: boolean; url: string; error: GraphQLError } {
	const { loading, data, error } = useReadFragment(FRAGMENT_PROPERTY_MODAL_TOUR3D, id);

	return {
		loading,
		url: data?.project[0]?.tour3d ?? "",
		error,
	};
}
